import { TextArea } from "@shared/components/TextArea";
import { TextField } from "@shared/components/TextField";
import { LIMITS, parseLines, type FormErrors, type IntroFormValues, type ListField, type TextField as TextKey } from "./introModel";

interface IntroFormProps {
  values: IntroFormValues;
  errors: FormErrors;
  onChange: (patch: Partial<IntroFormValues>) => void;
}

const charsHint = (value: string, limit: number) => {
  const left = limit - value.trim().length;
  return left >= 0 ? `Sisa ${left} karakter` : `Kelebihan ${-left} karakter`;
};

const LIST_HINT = `Satu butir per baris. Maksimal ${LIMITS.items} butir, ${LIMITS.item} karakter per butir.`;

export function IntroForm({ values, errors, onChange }: IntroFormProps) {
  const textArea = (field: TextKey, label: string, rows: number, limit: number) => (
    <TextArea
      label={label}
      rows={rows}
      value={values[field]}
      error={errors[field]}
      hint={charsHint(values[field], limit)}
      onChange={(e) => onChange({ [field]: e.target.value })}
    />
  );
  const list = (field: ListField, label: string) => (
    <TextArea
      label={label}
      rows={5}
      value={values[field]}
      error={errors[field]}
      hint={`${parseLines(values[field]).length} dari ${LIMITS.items} butir. ${LIST_HINT}`}
      onChange={(e) => onChange({ [field]: e.target.value })}
    />
  );

  return (
    <div className="form-grid">
      <TextField
        label="Tagline"
        value={values.tagline}
        error={errors.tagline}
        hint={charsHint(values.tagline, LIMITS.tagline)}
        onChange={(e) => onChange({ tagline: e.target.value })}
      />
      {textArea("overview", "Ikhtisar", 6, LIMITS.overview)}
      {list("measures", "Yang diukur")}
      {textArea("audience", "Cocok untuk", 3, LIMITS.audience)}
      {list("outcomes", "Yang kamu dapatkan")}
      {list("howItWorks", "Bagaimana cara kerjanya")}
      {list("tips", "Tips mengerjakan")}
      {textArea("disclaimer", "Disclaimer", 3, LIMITS.disclaimer)}
      <label className="check">
        <input type="checkbox" checked={values.isPlaceholder} onChange={(e) => onChange({ isPlaceholder: e.target.checked })} />
        Tandai sebagai placeholder
      </label>
    </div>
  );
}
